import $ from 'jquery';

export const getFullHeight = () => window.innerHeight;

const SCROLL_TOP_TO_CLOSE = 150;

// 1. Инициализирует плавное закрытие модального окна без скачков
// 2. При включенной опции swipeControl реализует закрытие модального окна в 2 свайпа:
// - по первому свайпу только прокрутка к началу модального окна,
// - по второму свайпу - закрытие.
export function popupScrollHandler($popup, swipeControl = false) {
  let endHeight;
  let lastHeight;
  /** @type boolean */
  let isFullScreen;

  function handleClose($popup) {
    if (
      !window.openingScrolling &&
      !window.closingPopup &&
      '#' + $popup.prop('id') === window.openedPopupsIdsStack[window.openedPopupsIdsStack.length - 1]
    ) {
      window.closingPopup = true;
      history.back();
      if (window.open_link_photo) $('html, body').animate({ scrollTop: $(window).scrollTop() }, 300);
    }
  }

  function handleTouchEnd() {
    endHeight = $(this).scrollTop();
    isFullScreen = endHeight > getFullHeight();
  }

  function handleScroll() {
    if ($(this).find('.popup-select__body').position()?.top <= 0) {
      $(this).find('.popup-select__header').addClass('popup-select__header-fixed');
      $(this).find('.popup-select__body').addClass('popup-select__body-fixed');
    } else {
      $(this).find('.popup-select__header').removeClass('popup-select__header-fixed');
      $(this).find('.popup-select__body').removeClass('popup-select__body-fixed');
    }

    const currentHeight = $(this).scrollTop();
    const scrollSpeed = Math.abs(lastHeight - currentHeight);
    lastHeight = currentHeight;
    if (currentHeight < SCROLL_TOP_TO_CLOSE) {
      if (currentHeight === 0 || scrollSpeed <= 5) {
        handleClose($(this));
      }
      return;
    }

    lastHeight = currentHeight;
    if (!swipeControl) return;

    if (!endHeight || currentHeight > endHeight) return;

    if (isFullScreen) {
      if (currentHeight < getFullHeight()) {
        $(this).stop(true, true).scrollTop(getFullHeight()).css('overflow', 'hidden');
      }
    }
  }

  function handleScrollEnd() {
    if (swipeControl) {
      setTimeout(() => $(this).css('overflow', ''), 10);
      endHeight = null;
    }

    const currentHeight = $(this).scrollTop();
    if (currentHeight < SCROLL_TOP_TO_CLOSE) {
      return handleClose($(this));
    }
  }

  return () => {
    if (swipeControl) {
      $popup.on('touchstart', function () {
        endHeight = null;
        $(this).css('overflow', '');
      });

      $popup.on('touchend', handleTouchEnd);
    }

    $popup.off('scroll').on('scroll', handleScroll);

    $popup.off('scrollend').on('scrollend', handleScrollEnd);
  };
}
